import i18n from 'scoreboard/components/i18n'
import prettyJoin from './pretty-joiner'

var codes = {
	'contains-any': 'report.filter.pretty.set.containsAny',
	'contains-all': 'report.filter.pretty.set.containsAll'
}

var PrettySet = function(filter) {
	return i18n.get(codes[filter.operator], prettyJoin(filter.values) )
}

export default PrettySet

PrettySet.__filename__ = 'reports/common/filter/pretty-set.js'
